'use strict';

var s = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var s__default = /*#__PURE__*/_interopDefault(s);

var a=({baseUrl:r,list:t})=>s__default.default.createElement("script",{type:"application/ld+json",dangerouslySetInnerHTML:{__html:JSON.stringify({"@context":"http://schema.org","@type":"BreadcrumbList",itemListElement:t.map((e,m)=>({"@type":"ListItem",position:m+1,item:{name:e.name,...e.url&&{"@id":`${r}${e.url}`}}}))})}}),i=a;

exports.a = i;
